module.exports = __webpack_public_path__ + "img/icon_start1.72b20f52-ce12f504.98b9c856.svg";